module.exports = __webpack_public_path__ + "static/img/6.ddb10fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/6.png
// module id = ETTC
// module chunks = 0